import {
  call,
  put,
  select,
  takeEvery,
  takeLatest
} from '@redux-saga/core/effects';
import { ActionType } from 'typesafe-actions';

import * as Actions from '../actions/analysisHistoryAction';
import * as Apis from '../apis/annalysisHistoryApi';
import * as Models from '../models/analysisHitoryModel';

function* listSaga(action: ActionType<typeof Actions.list.request>) {
  try {
    const { searchParams, page } = action.payload;

    const res = yield call(Apis.analysisHistory.list, searchParams, page);
    const {
      data: { items, total },
      count
    } = res;

    yield put(
      Actions.list.success({
        data: items,
        count,
        total
      })
    );
  } catch (error) {
    yield put(Actions.list.failure(error));
  }
}

function* detailSaga(action: ActionType<typeof Actions.detail.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.analysisHistory.detail, id);
    yield put(Actions.log.request(id));
    const { data } = res;
    yield put(
      Actions.detail.success({
        detail: data
      })
    );
  } catch (error) {
    yield put(Actions.detail.failure(error));
  }
}

function* logSaga(action: ActionType<typeof Actions.log.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.analysisHistory.log, id);
    const { data } = res;

    yield put(
      Actions.log.success({
        log: data
      })
    );
  } catch (error) {
    yield put(Actions.log.failure(error));
  }
}

export function* analysisHistorySaga() {
  yield takeEvery(Actions.list.request, listSaga);
  yield takeEvery(Actions.detail.request, detailSaga);
  yield takeEvery(Actions.log.request, logSaga);
}
